<template>
  <div>
    <div v-if="!isLoading" class="box box-default">
      <div class="box-header">
        <div class="flex align-items-center justify-between">
          <h3 class="box-title">Merchant Fees Custom</h3>
          <div class="flex align-items-center">
            <button class="btn btn-flat btn-primary btn-sm" @click="addMerchantFee()">Add Merchant Fee</button>
            <v-select v-model="merchantID" :options="merchants" :reduce="merchant => merchant.ID" class="ml-8"
                      label="ShopTitle" placeholder="Select Merchant" style="min-width: 200px;"></v-select>
            <v-select v-model="altCoinID" :options="coins" :reduce="coin => coin.ID" class="ml-8"
                      label="Name" placeholder="Select AltCoin" style="min-width: 200px;"></v-select>
          </div>
        </div>
      </div>
      <div class="box-body no-padding">
        <div class="table-responsive">
          <table class="table table-striped table-condensed">
            <thead>
            <tr>
              <th>ID</th>
              <th>Merchant</th>
              <th>Coin</th>
              <th class="pointer" @click="sort('MinerFee')">
                Miner Fee
                <span v-if="sortKey === 'MinerFee'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('Percentage')">
                Percentage
                <span v-if="sortKey === 'Percentage'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('MinerFeeAfter')">
                Miner Fee After
                <span v-if="sortKey === 'MinerFeeAfter'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('PercentageAfter')">
                Percentage After
                <span v-if="sortKey === 'PercentageAfter'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('CCRate')">
                CCRate
                <span v-if="sortKey === 'CCRate'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('CCFixedFee')">
                CCFixedFee
                <span v-if="sortKey === 'CCFixedFee'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPFee')">
                SWAPFee
                <span v-if="sortKey === 'SWAPFee'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPMinerFee')">
                SWAPMinerFee
                <span v-if="sortKey === 'SWAPMinerFee'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPFeeRange1')">
                SWAPFeeRange1
                <span v-if="sortKey === 'SWAPFeeRange1'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPFeeRange2')">
                SWAPFeeRange2
                <span v-if="sortKey === 'SWAPFeeRange2'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPFeeRange3')">
                SWAPFeeRange3
                <span v-if="sortKey === 'SWAPFeeRange3'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('SWAPFeeRange4')">
                SWAPFeeRange4
                <span v-if="sortKey === 'SWAPFeeRange4'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('CreatedOn')">
                Created On
                <span v-if="sortKey === 'CreatedOn'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
              <th class="pointer" @click="sort('UpdatedOn')">
                Updated On
                <span v-if="sortKey === 'UpdatedOn'" class="ml-4">
                  <i class="fa fa-sort"></i>
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-if="records.length > 0">
              <tr v-for="(record, index) in records" :key="index" @click="showFeeCalculator(record)">
                <td>{{ record.ID }}</td>
                <td class="no-wrap">
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'MerchantID')">
                    {{ record.ShopTitle + ' (' + record.OwnerNickName + ')' }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'AltCoinID')">
                    {{ record.Name + ' (' + record.LongName + ')' }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'MinerFee')">
                    {{ record.MinerFee }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'Percentage')">
                    {{ record.Percentage }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'MinerFeeAfter')">
                    {{ record.MinerFeeAfter }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'PercentageAfter')">
                    {{ record.PercentageAfter }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'CCRate')">
                    {{ record.CCRate }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'CCFixedFee')">
                    {{ record.CCFixedFee }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPFee')">
                    {{ record.SWAPFee }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPMinerFee')">
                    {{ record.SWAPMinerFee }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPFeeRange1')">
                    {{ record.SWAPFeeRange1 }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPFeeRange2')">
                    {{ record.SWAPFeeRange2 }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPFeeRange3')">
                    {{ record.SWAPFeeRange3 }}
                  </span>
                </td>
                <td>
                  <span class="pointer" @click="launchUpdateMerchantCustomFeeModal(record, 'SWAPFeeRange4')">
                    {{ record.SWAPFeeRange4 }}
                  </span>
                </td>
                <td class="no-wrap">{{ formatDate(record.CreatedOn) }}</td>
                <td class="no-wrap pr-16">{{ formatDate(record.UpdatedOn) }}</td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="17">No record found!</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div v-if="meta.total" class="footer">
          <pagination :meta="meta" @pageChange="updatePage"></pagination>
        </div>
      </div>
    </div>
    <div class="box box-default" v-if="isShowCalculatorForm">
      <div class="box-header">
        <div class="flex align-items-center justify-between">
          <h3 class="box-title">Calculate Fees Custom</h3>
        </div>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-6">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
                <ValidationProvider v-slot="{ errors }" class="form-group" name="MerchantID" rules="required"
                                    tag="div">
                  <label class="merchantID">Merchant</label>
                  <select id="merchantID" v-model="form.MerchantID" class="form-control">
                    <option v-for="(record, index) in merchantsList"
                            :key="index" :value="record.ID">{{ record.ShopTitle + ' (' + record.OwnerNickName + ')' }}
                    </option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="AltCoinID" rules="required" tag="div">
                  <label for="altCoinID">AltCoin</label>
                  <select id="altCoinID" v-model="form.AltCoinID" class="form-control">
                    <option v-for="(record, index) in onlineAltCoins"
                            :key="index" :value="record.ID">{{ record.Name + ' (' + record.LongName + ')' }}
                    </option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider v-slot="{ errors }" class="form-group" name="amount" rules="required" tag="div">
                  <label for="amount">Amount</label>
                  <input type="text" id="amount" v-model="form.Amount" class="form-control">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
                <div class="text-right">
                  <button :disabled="isBtnLoading" class="btn btn-primary btn-flat" type="submit">
                    <span>Calculate</span>
                    <span v-if="isBtnLoading"><i class="fa fa-circle-o-notch fa-spin ml-8"></i></span>
                  </button>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
        <div v-if="message">{{ message }}</div>
      </div>
    </div>
    <update-merchant-custom-fee-modal></update-merchant-custom-fee-modal>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import { START_LOADING, STOP_LOADING } from '@/store/keys'
import { formatDate, saveNotification } from '@/lib/utils'
import UpdateMerchantCustomFeeModal from '@/components/modals/UpdateMerchantCustomFeeModal'
import * as _ from 'lodash'

export default {
  name: 'MerchantFeesCustom',
  components: {
    Pagination,
    UpdateMerchantCustomFeeModal
  },
  data() {
    return {
      altCoinID: '',
      merchantID: '',
      records: [],
      coins: [],
      merchants: [],
      meta: {
        total: 0,
        page: 1,
        offset: 0,
        limit: Number.parseInt(process.env.VUE_APP_LIMIT, 10)
      },
      isShowCalculatorForm: false,
      merchantsList: [],
      form: {
        MerchantID: '',
        AltCoinID: '',
        Amount: ''
      },
      selectedRecord: null,
      message: '',
      isBtnLoading: false,
      sortKey: 'CreatedOn',
      order: 'desc'
    }
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'jwtToken',
      'currentUser',
      'onlineAltCoins'
    ])
  },
  watch: {
    altCoinID(val) {
      if (val === null) {
        this.altCoinID = ''
      }
      this.getPaginatedRecords(1)
    },
    merchantID(val) {
      if (val === null) {
        this.merchantID = ''
      }
      this.getPaginatedRecords(1)
    }
  },
  methods: {
    updatePage(page) {
      this.getPaginatedRecords(page)
    },
    sort(key) {
      if (key !== this.sortKey) {
        this.order = 'desc'
      } else {
        this.order = this.order === 'asc' ? 'desc' : 'asc'
      }
      this.sortKey = key
      this.getPaginatedRecords(1)
    },
    getPaginatedRecords(page = 1) {
      this.$store.commit(START_LOADING)
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=ListMisc&type=merchant_fees_custom`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        },
        params: {
          page,
          altCoinID: this.altCoinID,
          merchantID: this.merchantID,
          limit: Number.parseInt(this.meta.limit),
          order: this.sortKey,
          orderBy: this.order
        }
      }).then((response) => {
        this.$store.commit(STOP_LOADING)
        if (response.status === 200) {
          this.records = response.data.data.records
          this.coins = response.data.data.coins
          this.merchants = response.data.data.merchants
          this.meta = response.data.data.meta
        }
      }).catch(error => {
        this.$store.commit(STOP_LOADING)
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.data.message)
      })
    },
    getAllMerchants() {
      const apiBaseUrl = process.env.VUE_APP_ADMIN_API_URL
      this.$http.get(`${apiBaseUrl}/?Call=MerchantsList`, {
        headers: {
          Authorization: 'Bearer ' + this.jwtToken
        }
      }).then((response) => {
        this.merchantsList = response.data.data
        if (this.merchantsList.length > 0) {
          this.merchantsList = _.orderBy(this.merchantsList, ['ShopTitle'], ['asc'])
        }
      }).catch(error => {
        this.$toast.fire('', error.data.message, 'error')
        saveNotification(error.data.message)
      })
    },
    formatDate(val) {
      return formatDate(val)
    },
    addMerchantFee() {
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: {
          Call: 'MerchantFeesCustomInsert',
          MerchantID: 1,
          APIKey: '_',
          AltCoinID: 1,
          output: 'json'
        }
      }).then(response => {
        this.getPaginatedRecords()
      }).catch(error => {
        console.log(error)
      })
    },
    launchUpdateMerchantCustomFeeModal(record, key) {
      this.$bus.$emit('update-merchant-custom-fee-modal', {
        data: {
          ID: record.ID,
          Key: key,
          Value: record[key]
        },
        merchantsList: this.merchantsList,
        confirm: (id) => {
          this.getPaginatedRecords(this.meta.page)
        }
      })
    },
    showFeeCalculator(record) {
      this.message = ''
      this.form = {
        MerchantID: record.MerchantID,
        AltCoinID: record.AltCoinID,
        Amount: ''
      }
      this.selectedRecord = record
      this.isShowCalculatorForm = true
    },
    onSubmit() {
      this.isBtnLoading = true
      const apiBaseUrl = process.env.VUE_APP_API_URL
      this.$http.get(`${apiBaseUrl}/v2REAPI`, {
        params: {
          Call: 'CalculateFeesCustom',
          MerchantID: this.selectedRecord.MerchantID,
          APIKey: '_',
          AltCoinID: this.selectedRecord.AltCoinID,
          ID: this.selectedRecord.ID,
          Amount: this.form.Amount,
          output: 'json'
        }
      }).then(response => {
        this.isBtnLoading = false
        this.message = response.data.message
      }).catch(error => {
        this.isBtnLoading = false
        console.log(error)
      })
    }
  },
  mounted() {
    this.getPaginatedRecords()
    this.getAllMerchants()
  },
  beforeDestroy() {
    this.$store.commit(STOP_LOADING)
  }
}
</script>

<style scoped></style>
